class LeftMenuDropdown extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initializeProperties()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  initializeProperties() {
    this.menuCategoryItem = this.querySelector('.menu-category-item')
  }

  addEventListeners() {
    this.addEventListener('mouseenter', this.checkPosition.bind(this))
  }

  removeEventListeners() {
    this.removeEventListener('mouseenter', this.checkPosition.bind(this))
  }

  checkPosition() {
    const overflowAmount = this.calculateOverflow()
    this.updateDropdownPosition(overflowAmount)
  }

  calculateOverflow() {
    const { top: menuPosition } = this.getBoundingClientRect()
    const { offsetHeight: menuCategoryHeight } = this.menuCategoryItem
    const dropdownContentPosition = menuPosition + menuCategoryHeight + 10
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight
    const overflowAmount = Math.max(0, dropdownContentPosition - viewportHeight)

    return overflowAmount
  }

  updateDropdownPosition(overflowAmount) {
    const { top, bottom } = { top: `-${overflowAmount}px`, bottom: 'auto' }
    this.setDropdownStyle(top, bottom)
  }

  setDropdownStyle(top, bottom) {
    Object.assign(this.menuCategoryItem.style, {
      top,
      bottom,
    })
  }
}

customElements.define('left-menu-dropdown', LeftMenuDropdown)
